import React from "react";
import { Form, Table } from "@redriver/cinnamon";
import {
  DeleteDocumentModal,
  DownloadDocumentModal,
  EditDocumentModal,
  SendDocumentToAppModal,
} from "components/modals";
import {
  deleteJobDocument,
  getJobDocument,
  updateJobDocument,
  updateJobDocumentSendToApp,
} from "./actions";
import { PermissionCheck } from "components/auth";
import { Actions, Targets } from "constants/Permissions";
import { DocumentTypesDropdown } from "components/forms";

const JobDocumentTableActions = ({
  document,
  jobId,
  onRefresh,
  jobSheetOptions,
  departmentId,
}) => (
  <Table.Menu openOnFocus>
    <DownloadDocumentModal
      document={document}
      action={getJobDocument}
      actionParams={{ jobId }}
      as={Table.MenuItem}
    >
      Download Document
    </DownloadDocumentModal>
    {!document.isReadOnly && (
      <PermissionCheck target={Targets.ContractJob} action={Actions.Edit}>
        <EditDocumentModal
          document={document}
          submitAction={updateJobDocument}
          submitParams={{ jobId }}
          onUpdated={onRefresh}
          documentTypeDropdown={
            <DocumentTypesDropdown
              field="documentTypeId"
              label="Type"
              placeholder="Select document type"
              required
              fluid
              departmentId={departmentId}
            />
          }
          as={Table.MenuItem}
          extraContent={
            <Form.Group widths={2}>
              <Form.Dropdown
                field="jobSheetId"
                label="Related Visit"
                placeholder="Optionally select"
                options={jobSheetOptions}
                fluid
                clearable
              />
            </Form.Group>
          }
        >
          Edit Document
        </EditDocumentModal>
      </PermissionCheck>
    )}

    <PermissionCheck target={Targets.ContractJob} action={Actions.Edit}>
      <SendDocumentToAppModal
        document={document}
        submitAction={updateJobDocumentSendToApp}
        submitParams={{ jobId }}
        onUpdated={onRefresh}
        as={Table.MenuItem}
      >
        {document.sendToApp ? "Do Not Send to App" : "Send to App"}
      </SendDocumentToAppModal>
    </PermissionCheck>

    <PermissionCheck target={Targets.ContractJob} action={Actions.Edit}>
      <DeleteDocumentModal
        document={document}
        action={deleteJobDocument}
        actionParams={{ jobId }}
        onDeleted={onRefresh}
        as={Table.MenuItem}
      >
        Delete Document
      </DeleteDocumentModal>
    </PermissionCheck>
  </Table.Menu>
);

export default JobDocumentTableActions;
